module.exports = __webpack_public_path__ + "paper_packaging_jewellery_rvcnn_fashion_design_paperbag.jpg?33f1a158160d91dc63c96e68cc8213ba";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/rvcnn/paper_packaging_jewellery_rvcnn_fashion_design_paperbag.jpg
// module id = 98
// module chunks = 0